export const IMPORT_ALLOWED_FILE_TYPES = [
  { label: "JPEG", mimeTypes: ["image/jpeg"] },
  { label: "PNG", mimeTypes: ["image/png"] },
  {
    label: "ZIP",
    mimeTypes: [
      "application/zip",
      "application/x-zip",
      "application/x-zip-compressed",
      "application/octet-stream",
    ],
  },
] as const;

export const IMPORT_ALLOWED_FILE_TYPES_ACCEPT = IMPORT_ALLOWED_FILE_TYPES.flatMap(
  ({ mimeTypes }) => mimeTypes
).join(", ");

export const IMPORT_ALLOWED_FILE_TYPES_LABEL = IMPORT_ALLOWED_FILE_TYPES.map(
  ({ label }) => label
).join(", ");

export const JSON_FILE_ACCEPT = "application/json,.json";

export const JSON_FILE_TYPES_LABEL = "JSON";
